import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import FreqPowerCard from "../DeviceFreqToPower/FreqPowerCard";
import AppButton from "../../Common/Button/Button";
import { AllowedConversionType, convertCapabilityName, isJsonParseSuccessful, isJsonStringifySuccessful, validateJSONData } from "../../../utils/general";
import { Box } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import FormInput from "../../Common/FormInputs/MuiTextField";
import { selectMenuProps } from "../../../utils/selectMenuProps";
import { useTheme } from "@mui/material/styles";
import { useDesignTokens } from "../../../theme/useDesignTokens";

const selectInputSx = { height: 45, minHeight: 45, width: "100%", "& .MuiOutlinedInput-notchedOutline": { border: "1px solid rgba(0, 0, 0, 0.42) !important" } };
const capabilityCardSx = { marginBottom: "15px", backgroundColor: "#f2f2f2" };
const deleteCapabilityCardButtonSx = { float: "right" };
const selectValuesSx = { width: "100%" };
const attributeKeySx = { marginRight: '20px' };

const CONFIG = {
  customJson: {
    label: "Custom Capability JSON",
    placeholder: `e.g., {"capability": "PowerfulMode","attributes": [{"key": "acpm"}]} `,
    rows: 4,
    helpText: "Valid JSON format is required",
  },
};

const DeviceModelStatusCapability = ({
    productCategory,
    isDeviceModelAddedUsingFileUpload,
    triggerAddNewDeviceModel,
    addDeviceStatusCapabilties,
    editDeviceModel,
    deviceModelData,
    ModelData: { deviceModelsMetadata },
    freqPowerBodies,
    setFreqPowerBodies,
    removeFreqPowerRow,
    addFreqPowerRow,
    freqToPowerData,
    initialFreqPower,
    areAllCustomJsonValidCheck
}) => {
    const theme = useTheme();
    const { colors } = useDesignTokens();
    const primaryColor = colors?.primary?.main || theme.palette.primary.main;
    const inputFieldHeight = 45;
    const focusOutlineSx = {
        "& .MuiOutlinedInput-root": { height: inputFieldHeight, minHeight: inputFieldHeight },
        "& .MuiInputBase-input": { height: `${inputFieldHeight}px !important`, minHeight: `${inputFieldHeight}px !important`, boxSizing: "border-box" },
        "& .MuiOutlinedInput-notchedOutline": { border: "1px solid rgba(0, 0, 0, 0.42) !important" },
        "& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(0, 0, 0, 0.87)" },
        "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
            borderColor: `${primaryColor} !important`, borderWidth: "1px",
        },
        "& .MuiOutlinedInput-root.Mui-expanded .MuiOutlinedInput-notchedOutline": {
            borderColor: "rgba(0, 0, 0, 0.42) !important", borderWidth: "1px",
        },
        "& .MuiInputLabel-root.Mui-focused, & .MuiInputLabel-root.Mui-expanded": { color: `${primaryColor} !important` },
    };

    const customCapabilityName = "CustomCapability";
    const [customCapabilityCount, setCustomCapabilityCount] = useState(1);
    const [statusCapabiltiesList, setStatusCapabiltiesList] = useState(() => {
        const capabilities = Object.keys(
            deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities ?? {}
        ).sort();
        return Array.from(new Set([customCapabilityName, ...capabilities]));
    });
    const [selectedStatusCapability, setSelectedStatusCapability] = useState(() => {
        const capabilities = Object.keys(
            deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities ?? {}
        ).sort();
        const list = Array.from(new Set([customCapabilityName, ...capabilities]));
        return list?.[0] ?? "";
    });
    const [addedStatusCapabilities, setAddedStatusCapabilities] = useState([]);
    const [statusCapabilitiesAttributes, setStatusCapabilitiesAttributes] = useState({});
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const areAllCustomJsonValid = (errorsObj) => {
        return Object.values(errorsObj).every(error => error === "");
    };

    useEffect(() => {
        let nextSelectedCapability = ""
        if (statusCapabiltiesList && statusCapabiltiesList.length > 0) {
            nextSelectedCapability = statusCapabiltiesList[0]
        }
        setSelectedStatusCapability(nextSelectedCapability)

    }, [statusCapabiltiesList])

    useEffect(() => {
        let stsCapabilitiesAttributes = {}

        if (editDeviceModel || isDeviceModelAddedUsingFileUpload) {
            let statusCapabilities = deviceModelData.statusCapabilitiesV2?deviceModelData.statusCapabilitiesV2:[];

            for (let capability of statusCapabilities) {
                let capabilityName = capability['capability']
                if( (deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities) && !([capabilityName] in deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities)){
                    stsCapabilitiesAttributes[[capabilityName]] = isJsonStringifySuccessful(capability, {formatted: true})
                }
                else{
                    stsCapabilitiesAttributes[capabilityName] = {}
                    let attributes = capability['attributes'];

                    if (attributes) {
                        stsCapabilitiesAttributes[capabilityName]["attributes"] = {}

                        for (let index in attributes) {
                            stsCapabilitiesAttributes[capabilityName]["attributes"][index] = {}
                            stsCapabilitiesAttributes[capabilityName]["attributes"][index]['key'] = attributes[index]['key']
                        }
                    }
                }
            }
        }

        let statusCapabilities = deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities;
        if (statusCapabilities) {
            for (let capabilityName in statusCapabilities) {

                if (stsCapabilitiesAttributes.hasOwnProperty(capabilityName)) {
                    continue;
                }

                stsCapabilitiesAttributes[capabilityName] = {}
                let attributes = statusCapabilities[capabilityName]['attributes'];
                if (attributes) {
                    stsCapabilitiesAttributes[capabilityName]["attributes"] = {}

                    for (let index in attributes) {
                        stsCapabilitiesAttributes[capabilityName]["attributes"][index] = {}
                        stsCapabilitiesAttributes[capabilityName]["attributes"][index]['key'] = attributes[index]['key'] ? attributes[index]['key'] : ""
                    }
                }
            }
        }
        setStatusCapabilitiesAttributes(stsCapabilitiesAttributes)

    }, [productCategory, editDeviceModel, isDeviceModelAddedUsingFileUpload])

    useEffect(() => {
        if (editDeviceModel || isDeviceModelAddedUsingFileUpload) {
            let addedStatusCapabilitiesList = [];
            const statusCapabilitiesV2 = Array.isArray(deviceModelData?.statusCapabilitiesV2)
                ? deviceModelData.statusCapabilitiesV2
                : [];
            for (let statusCapability of statusCapabilitiesV2) {
                addedStatusCapabilitiesList.push(statusCapability.capability)
            }

            setAddedStatusCapabilities(addedStatusCapabilitiesList);
            setStatusCapabiltiesList((prevState) => {
                // return prevState.filter((capabilityName) => !(addedStatusCapabilitiesList.includes(capabilityName))).sort();
                return prevState.filter((capabilityName) => !(addedStatusCapabilitiesList.includes(capabilityName)));
            });
        } else {
            // setStatusCapabiltiesList(deviceModelsMetadata["categories"][productCategory] ? Object.keys(deviceModelsMetadata["categories"][productCategory]["statusCapabilities"]) : []);
            setStatusCapabiltiesList(() => {
            const capabilities =
                deviceModelsMetadata["categories"][productCategory]
                ? Object.keys(deviceModelsMetadata["categories"][productCategory]["statusCapabilities"]).sort()
                : [];

            return [
                customCapabilityName,
                ...capabilities.filter(cap => cap !== customCapabilityName),
            ];
            });
            setAddedStatusCapabilities([]);
        }
    }, [productCategory, editDeviceModel, isDeviceModelAddedUsingFileUpload])

    useEffect(() => {
        if (triggerAddNewDeviceModel) {
            let statusCapabilitiesData = getStatusCapabilityData();
            addDeviceStatusCapabilties(statusCapabilitiesData)
            areAllCustomJsonValidCheck(areAllCustomJsonValid(errors), "status")
        }
    }, [triggerAddNewDeviceModel])

    function handleSelectStatusCapability(selectedCapability) {
        setSelectedStatusCapability(selectedCapability)
    }

    function handleAddStatusCapability(addedCapabilityName) {        
        if(addedCapabilityName === customCapabilityName){
            addedCapabilityName = addedCapabilityName + customCapabilityCount;

            setStatusCapabilitiesAttributes(prev => ({
                ...prev,
                [addedCapabilityName]: isJsonStringifySuccessful({}, {formatted: true})
            }));

            setAddedStatusCapabilities((prevState) => {
                return [...prevState, addedCapabilityName]
            })

            setCustomCapabilityCount((prev) => prev + 1);
        }
        else{
            setAddedStatusCapabilities((prevState) => {
                return [...prevState, addedCapabilityName]
            })

            setStatusCapabiltiesList((prevState) => {
                // return prevState.filter((capabilityName) => capabilityName!==selectedStatusCapability).sort()
                return prevState.filter((capabilityName) => capabilityName!==selectedStatusCapability)
            })
        }
    }

    const isCustomCapability = (value) => value.startsWith(customCapabilityName);

    function handleRemoveStatusCapability(removedCapabilityName) {
        // handle custom removal logic
        if ((isCustomCapability(removedCapabilityName)) || !((deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities) && ([removedCapabilityName] in deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities)) ) {
            setStatusCapabilitiesAttributes(prev => {
                const { [removedCapabilityName]: _, ...rest } = prev;
                return rest;
            });

            setAddedStatusCapabilities((prevState) => {
                return prevState.filter((capabilityName) => capabilityName!==removedCapabilityName).sort()
            })

            setErrors(prev => {
                const { [removedCapabilityName]: _, ...rest } = prev;
                return rest;
            });

            setTouched(prev => {
                const { [removedCapabilityName]: _, ...rest } = prev;
                return rest;
            });
        }
        else{
            setAddedStatusCapabilities((prevState) => {
                return prevState.filter((capabilityName) => capabilityName!==removedCapabilityName).sort()
            })

            setStatusCapabiltiesList((prevState) => {
                return [...prevState, removedCapabilityName]
            })

            if (removedCapabilityName === "PowerConsumption") {
                setFreqPowerBodies([{ frequency: "", rrpm_c: "", power: "" }]);
            }
        }
    }

    function onChangeCapabilityCustomJson(capabilityName, value) {
        let capabilityAttributes = { ...statusCapabilitiesAttributes }

        capabilityAttributes[capabilityName] = value

        handleStatusCapabilitiesAttributes(capabilityAttributes)

        const error = validateJSONData(value);
        setErrors((prev) => ({ ...prev, [capabilityName]: error }));
        if (error && error !== "") {
            setTouched((prev) => ({ ...prev, [capabilityName]: "true" }));
        }
    }

    function onChangeCapabilityCustomJson(capabilityName, value) {
        setStatusCapabilitiesAttributes((prev) => ({ ...prev, [capabilityName]: value }));
        const error = validateJSONData(value);
        setErrors((prev) => ({ ...prev, [capabilityName]: error }));
        if (error && error !== "") {
            setTouched((prev) => ({ ...prev, [capabilityName]: "true" }));
        }
    }

    function onChangeAttributeKeyName(capabilityName, attributeIndex, keyName) {
        let capabilityAttributes = { ...statusCapabilitiesAttributes }
        capabilityAttributes[capabilityName]["attributes"][attributeIndex]["key"] = keyName

        handleStatusCapabilitiesAttributes(capabilityAttributes)
    }

    function handleStatusCapabilitiesAttributes(capabilityAttributes) {
        setStatusCapabilitiesAttributes(capabilityAttributes)
    }

    function getStatusCapabilityData() {
        let statusCapabilities = []
        for (let capabilityName of addedStatusCapabilities) {
            if( (isCustomCapability(capabilityName)) || !((deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities) && ([capabilityName] in deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities)) ){
                if(isJsonParseSuccessful(statusCapabilitiesAttributes[capabilityName], { logError: false }) !== false){
                    statusCapabilities.push(isJsonParseSuccessful(statusCapabilitiesAttributes[capabilityName]))
                }
            }
            else{
                let capabilityData = {}
                capabilityData['capability'] = capabilityName

                let attributes = statusCapabilitiesAttributes[capabilityName]['attributes'];
                if(attributes){
                    capabilityData['attributes'] = []
                }
                for (let index in attributes) {
                    let attributeData = {}
                    attributeData['key'] = attributes[index]['key']
                    capabilityData['attributes'].push(attributeData)
                }

                statusCapabilities.push(capabilityData)
            }
        }
        return statusCapabilities;
    }

    return (
        <Fragment>
            <Grid2 container spacing={2} sx={{ alignItems: "flex-end", mt: 1.5, mb: 2 }}>
                <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <FormInput
                        type="select"
                        label="Select Capability"
                        value={selectedStatusCapability}
                        onChange={(e) => handleSelectStatusCapability(e.target.value)}
                        options={(statusCapabiltiesList ?? []).map((capabilityName) => ({
                            value: capabilityName,
                            label: convertCapabilityName(capabilityName),
                        }))}
                        fullWidth
                        size="small"
                        sx={selectInputSx}
                        MenuProps={selectMenuProps}
                        inputProps={{ "aria-label": "Select capability" }}
                    />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                    <Box sx={{ height: "1.25rem", mb: 0.75 }} aria-hidden />
                    <AppButton
                        variant="primary"
                        size="medium"
                        onClick={() => handleAddStatusCapability(selectedStatusCapability)}
                        disabled={statusCapabiltiesList && statusCapabiltiesList.length === 0}
                    >
                        Add Capability
                    </AppButton>
                </Grid2>
            </Grid2>
            {
                addedStatusCapabilities.map((capabilityName) => {
                    const isCustom = isCustomCapability(capabilityName) ||
                        !(deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities &&
                            capabilityName in deviceModelsMetadata.categories[productCategory].statusCapabilities);
                    return <Fragment key={productCategory + '_' + capabilityName}>
                        <Card variant="outlined" sx={capabilityCardSx} key={capabilityName}>
                            { (isCustomCapability(capabilityName)
                                || !((deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities) && ([capabilityName] in deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities))
                            ) ?
                                <CardContent>
                                    <Grid2 container alignItems="flex-start" spacing={1}>
                                        <Grid2 size={10} sx={{margin: 'auto'}}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                            {CONFIG?.customJson?.label}
                                            </Typography>
                                        </Grid2>
    
                                        <Grid2 size={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
                                            <IconButton
                                            aria-label="delete"
                                            onClick={() => handleRemoveStatusCapability(capabilityName)}
                                            sx={{ p: 0.5 }}
                                            >
                                            <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </Grid2>

                                        <FormInput
                                            id={capabilityName}
                                            name={capabilityName}
                                            type="textarea"
                                            multiline
                                            rows={CONFIG?.customJson?.rows}
                                            fullWidth
                                            value={statusCapabilitiesAttributes[capabilityName]}
                                            onChange={(e) => onChangeCapabilityCustomJson(capabilityName, e.target.value)}
                                            placeholder={CONFIG?.customJson?.placeholder}
                                            error={!!errors?.[capabilityName]}
                                            touched={touched[capabilityName]}
                                            helperText={errors?.[capabilityName] || CONFIG?.customJson?.helpText}
                                            sx={{
                                            "& .MuiOutlinedInput-input": {
                                                padding: "2px 6px !important",
                                                height: "130px !important",
                                            },
                                            "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                borderWidth: `2px solid !important`,
                                            },
                                            }}
                                            slotProps={{
                                                htmlInput: {
                                                    maxLength: 10000,
                                                },
                                            }}
                                        />
                                    </Grid2>
                                </CardContent>
                                :
                            <CardContent>
                                {isCustom ? (
                                    <Grid2 container spacing={1} alignItems="flex-start">
                                        <Grid2 size={{ xs: 10, sm: 10 }} sx={{ margin: "auto", minWidth: 0 }}>
                                            <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>
                                                {CONFIG.label}
                                            </Typography>
                                        </Grid2>
                                        <Grid2 size={{ xs: 2, sm: 2 }} sx={{ display: "flex", justifyContent: "flex-end", flexShrink: 0 }}>
                                            <IconButton
                                                aria-label="delete"
                                                onClick={() => handleRemoveStatusCapability(capabilityName)}
                                                sx={{ p: 0.5 }}
                                            >
                                                <DeleteIcon fontSize="small" />
                                            </IconButton>
                                        </Grid2>
                                        <Grid2 size={12}>
                                            <FormInput
                                                id={capabilityName}
                                                name={capabilityName}
                                                type="textarea"
                                                multiline
                                                rows={CONFIG.rows}
                                                fullWidth
                                                value={typeof statusCapabilitiesAttributes[capabilityName] === "string" ? statusCapabilitiesAttributes[capabilityName] : ""}
                                                onChange={(e) => onChangeCapabilityCustomJson(capabilityName, e.target.value)}
                                                placeholder={CONFIG.placeholder}
                                                error={!!errors?.[capabilityName]}
                                                touched={touched[capabilityName]}
                                                helperText={errors?.[capabilityName] || CONFIG.helpText}
                                                sx={{
                                                    width: "100%",
                                                    minWidth: "100%",
                                                    "& .MuiOutlinedInput-root": {
                                                        minHeight: 220,
                                                        height: "auto",
                                                        alignItems: "flex-start",
                                                        "& .MuiOutlinedInput-notchedOutline": { border: "1px solid rgba(0, 0, 0, 0.42) !important" },
                                                    },
                                                    "& .MuiInputBase-input": {
                                                        minHeight: "200px !important",
                                                        height: "auto !important",
                                                        boxSizing: "border-box",
                                                        padding: "8.5px 14px !important",
                                                    },
                                                }}
                                            />
                                        </Grid2>
                                    </Grid2>
                                ) : (
                                    <>
                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 1, mb: 1 }}>
                                    <Typography variant="button" sx={{ flex: "1 1 auto", minWidth: 0 }}>{convertCapabilityName(capabilityName)}</Typography>
                                    <IconButton aria-label="delete" onClick={(e) => {
                                        handleRemoveStatusCapability(capabilityName)
                                    }} sx={{ flexShrink: 0, p: 0.5 }}>
                                        <DeleteIcon fontSize="small" />
                                    </IconButton>
                                </Box>
                                {deviceModelsMetadata?.categories?.[productCategory]?.statusCapabilities?.[capabilityName]?.attributes?.map((element, index) => {
                                        return <Grid2 key={capabilityName + '_' + index} container alignItems="flex-start" sx={{ mb: 2 }}>
                                            <Grid2 size={{ xs: 12, sm: 1 }}>
                                                <Typography>Attribute</Typography>
                                            </Grid2>
                                            <Grid2 size={{ xs: 12, sm: 4 }} sx={attributeKeySx}>
                                                <FormInput
                                                    placeholder="Enter Key Name"
                                                    value={statusCapabilitiesAttributes[capabilityName]["attributes"][index]["key"]}
                                                    disabled={true}
                                                    onChange={(e) => onChangeAttributeKeyName(capabilityName, index, e.target.value)}
                                                    sx={focusOutlineSx}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid2>
                                        </Grid2>
                                    })}
                                {productCategory === "AC" && capabilityName === "PowerConsumption" && (
                                    <>
                                    
                                    <div style={{ marginTop: "10px" }}>
                                      <FreqPowerCard
                                        bodies={freqPowerBodies}
                                        setBodies={setFreqPowerBodies}
                                        onRemove={removeFreqPowerRow}
                                        disabled={initialFreqPower.length===15 ? editDeviceModel : false}                                      />
                                       {freqPowerBodies.length < 15 && (
                                        <AppButton
                                            variant="primary"
                                            size="medium"
                                            onClick={addFreqPowerRow}
                                            sx={{ mt: 1.25 }}
                                        >
                                            Add Record
                                        </AppButton>
                                       )}
                                    </div>
                                    </>
                                  )}
                                    </>
                                )}
                            </CardContent>
                            }
                        </Card>
                    </Fragment>
                })
            }
        </Fragment>
    )
}

const mapStateToProps = (state) => ({
    ModelData: state.getModel,
    freqToPowerData: state.report.freqToPowerData
});

export default connect(mapStateToProps)(DeviceModelStatusCapability);